import {
  productFamilyImageIdFormat,
  productImageIdFormat,
} from "@redotech/redo-ids/ids";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateImageDefaults = {
  name: "updateImageDefaults" as const,
  input: z.object({
    updates: z.array(
      z.object({
        imageId: z.union([
          productFamilyImageIdFormat.schema,
          productImageIdFormat.schema,
        ]),
        imageType: createEnum(["productFamily", "product"]),
        isDefault: z.boolean(),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
